module.exports = __webpack_public_path__ + "img/heuristic-card.f1b888b3.png";